/* eslint-disable */

import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import {
  Button,
  Space,
  Typography,
  Modal,
  Form,
  Input,
  InputNumber,
  message,
  Select,
  Row,
  Col,
} from 'antd';
import {
  FileImageOutlined,
  PlusOutlined,
  ReloadOutlined,
  SearchOutlined,
  ScanOutlined,
  TagOutlined,
} from '@ant-design/icons';
import { useProductItemList } from './useProductItemList';
import CardProductDemo from '../../components/card-product/CardProductDemo';
import BarcodeScanner from '../../components/scanner/BarcodeScanner';
import './ConsoleProductItems.css';

dayjs.extend(buddhistEra);
dayjs.locale('th');

const { Title, Text } = Typography;

function ProductItemPreview(props) {
  const [form] = Form.useForm();
  const [PreviewImage1, setPreviewImage1] = useState('/images/blank.png');
  const [PreviewImage2, setPreviewImage2] = useState('/images/blank.png');
  const [PreviewImage3, setPreviewImage3] = useState('/images/blank.png');

  const [productcategory_selected, setProductCategory_Selected] = useState('');
  const [filtertext, setFiltertext] = useState('');

  const [productitem_selected, setProductItem_Selected] = useState({});
  const [productmode, setProductmode] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [isSearchScannerOpen, setIsSearchScannerOpen] = useState(false);

  const [imageFile1, setImageFile1] = useState(null);
  const [imageFile2, setImageFile2] = useState(null);
  const [imageFile3, setImageFile3] = useState(null);

  const { productitem_list, productcategory_list, loading, reload } = useProductItemList({
    app_hostname: props.app_hostname,
    permitdata: props.permitdata,
    filter: 'approved',
  });


  useEffect(() => {
    if (productcategory_selected === '' && productcategory_list.length > 0) {
      setProductCategory_Selected(productcategory_list[0].productcategory_id);
    }
  }, [productcategory_list, productcategory_selected]);

  const productitem_list_filtered = useMemo(() => {
    const search = filtertext.toLowerCase().trim();
    if (search !== '') {
      return productitem_list.filter(
        (item) =>
          item.productitem_id?.toLowerCase().includes(search) ||
          item.productitem_name?.toLowerCase().includes(search) ||
          item.productitem_inter?.toLowerCase().includes(search) ||
          (item.productitem_barcode && item.productitem_barcode.toLowerCase().includes(search)),
      );
    } else {
      return productitem_list.filter(
        (item) => item.productcategory_id === productcategory_selected,
      );
    }
  }, [productitem_list, productcategory_selected, filtertext]);

  function handleAdd() {
    setProductmode('add');
    setProductItem_Selected({});
    form.resetFields();
    form.setFieldsValue({
      productcategory_id: productcategory_selected,
      productitem_id: '-',
    });
    setPreviewImage1('/images/blank.png');
    setPreviewImage2('/images/blank.png');
    setPreviewImage3('/images/blank.png');
    setImageFile1(null);
    setImageFile2(null);
    setImageFile3(null);
    setIsModalOpen(true);
  }

  function handleEdit(record) {
    setProductmode('edit');
    setProductItem_Selected(record);
    form.setFieldsValue({
      productcategory_id: record.productcategory_id,
      productitem_id: record.productitem_id,
      productitem_name: record.productitem_name,
      productitem_inter: record.productitem_inter,
      productitem_desc: record.productitem_desc,
      productitem_barcode: record.productitem_barcode,
      productitem_width: record.productitem_width,
      productitem_height: record.productitem_height,
      productitem_deep: record.productitem_deep,
      productitem_weight: record.productitem_weight,
    });

    setPreviewImage1(
      props.app_hostname +
        '/api/product/file/productitem/' +
        record.productitem_id +
        '/' +
        record.productitem_id +
        '-1-' +
        record.img1_key +
        '.jpg',
    );
    setPreviewImage2(
      props.app_hostname +
        '/api/product/file/productitem/' +
        record.productitem_id +
        '/' +
        record.productitem_id +
        '-2-' +
        record.img2_key +
        '.jpg',
    );
    setPreviewImage3(
      props.app_hostname +
        '/api/product/file/productitem/' +
        record.productitem_id +
        '/' +
        record.productitem_id +
        '-3-' +
        record.img3_key +
        '.jpg',
    );
    setImageFile1(null);
    setImageFile2(null);
    setImageFile3(null);
    setIsModalOpen(true);
  }

  async function handleSubmit(values) {
    setModalLoading(true);

    let file1 = imageFile1;
    let file2 = imageFile2;
    let file3 = imageFile3;

    if (productmode === 'add') {
      try {
        const response = await fetch((process.env.PUBLIC_URL || '') + '/images/placeholder.webp');
        const blob = await response.blob();
        const placeholderFile = new File([blob], 'placeholder.webp', { type: 'image/webp' });

        if (!file1) file1 = placeholderFile;
        if (!file2) file2 = placeholderFile;
        if (!file3) file3 = placeholderFile;
      } catch (error) {
        console.error('Failed to load placeholder image:', error);
      }
    }

    const formData = new FormData();
    formData.append('productcategory_name', values.productcategory_id);
    formData.append('productitem_id', values.productitem_id);
    formData.append('productitem_name', values.productitem_name);
    formData.append('productitem_inter', values.productitem_inter);
    formData.append('productitem_desc', values.productitem_desc);
    formData.append('productitem_barcode', values.productitem_barcode);
    formData.append('productitem_width', values.productitem_width);
    formData.append('productitem_height', values.productitem_height);
    formData.append('productitem_deep', values.productitem_deep);
    formData.append('productitem_weight', values.productitem_weight);
    formData.append('username', props.permitdata.username);

    if (file1) formData.append('productimage1', file1);
    if (file2) formData.append('productimage2', file2);
    if (file3) formData.append('productimage3', file3);

    axios
      .post(props.app_hostname + '/api/product/item/' + productmode, formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setModalLoading(false);
        setProductItem_Selected({});
        if (response.data.status === 'OK') {
          reload();
          setIsModalOpen(false);
          message.success('บันทึกรายการสินค้าสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        setModalLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  const handleImageChange1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile1(file);
      setPreviewImage1(URL.createObjectURL(file));
    }
  };

  const handleImageChange2 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile2(file);
      setPreviewImage2(URL.createObjectURL(file));
    }
  };

  const handleImageChange3 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile3(file);
      setPreviewImage3(URL.createObjectURL(file));
    }
  };

  function callback_editproduct(item) {
    handleEdit(item);
  }

  return (
    <div className='page-wrapper'>
      <div className='page-card'>
        <Space direction='vertical' size='large' style={{ width: '100%' }}>
          <div className='page-header-actions'>
            <div style={{ marginBottom: props.isMobile ? '12px' : 0 }}>
              <Title level={props.isMobile ? 4 : 3} style={{ margin: 0 }}>
                <FileImageOutlined style={{ color: '#fa8c16', marginRight: '8px' }} />
                พรีวิวสินค้า
              </Title>
              <Text type='secondary'>ดูตัวอย่างรายการสินค้าทั้งหมดด้วยรูปแบบการ์ด</Text>
            </div>
            <Space
              size={props.isMobile ? 'small' : 'middle'}
              wrap
              style={{ width: props.isMobile ? '100%' : 'auto' }}
            >
              <Button
                icon={<PlusOutlined />}
                type='primary'
                onClick={handleAdd}
                block={props.isMobile}
              >
                เพิ่มใหม่
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={reload}
                loading={loading}
                block={props.isMobile}
              >
                รีเฟรช
              </Button>
            </Space>
          </div>

          <Row gutter={[16, 16]} align='middle'>
            <Col xs={24} md={8} lg={6}>
              <Text strong>หมวดหมู่สินค้า:</Text>
              <Select
                value={productcategory_selected}
                onChange={(value) => {
                  setProductCategory_Selected(value);
                  setFiltertext('');
                }}
                style={{ width: '100%', marginTop: '8px' }}
                options={productcategory_list.map((c) => ({
                  label: c.productcategory_name,
                  value: c.productcategory_id,
                }))}
              />
            </Col>
            <Col xs={24} md={16} lg={12}>
              <Text strong>ค้นหาสินค้า:</Text>
              <Input
                placeholder='รหัสสินค้า, ชื่อสินค้า (ไทย/อังกฤษ), บาร์โค้ด'
                value={filtertext}
                onChange={(e) => setFiltertext(e.target.value)}
                allowClear
                prefix={<SearchOutlined />}
                suffix={
                  <Button
                    type='text'
                    size='small'
                    icon={<ScanOutlined style={{ color: '#fa8c16', fontSize: '16px' }} />}
                    onClick={() => setIsSearchScannerOpen(true)}
                    title='สแกนบาร์โค้ดเพื่อค้นหา'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: 'none',
                      padding: '4px',
                      height: 'auto',
                    }}
                  />
                }
                style={{ width: '100%', marginTop: '8px' }}
              />
            </Col>
          </Row>

          <div>
            <Title level={5} style={{ marginBottom: '16px' }}>
              รายการพรีวิวสินค้า <span>({productitem_list_filtered.length} รายการ)</span>
            </Title>
            <Row gutter={[16, 16]}>
              {productitem_list_filtered.map((item, index) => (
                <Col xs={24} sm={12} md={8} lg={6} xl={4} key={item.productitem_id}>
                  <CardProductDemo
                    shopitem={item}
                    show_stock={false}
                    show_shop={true}
                    first_pricebase={99}
                    callback_editproduct={(message) => {
                      callback_editproduct(message);
                    }}
                  />
                </Col>
              ))}
            </Row>
          </div>
        </Space>
      </div>

      <Modal
        title={
          <Space>
            <TagOutlined />
            {productmode === 'add' ? 'เพิ่มสินค้า' : 'แก้ไขสินค้า'}
          </Space>
        }
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={props.isMobile ? '95%' : 1000}
        centered
      >
        <Form form={form} layout='vertical' onFinish={handleSubmit} style={{ marginTop: '24px' }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={10}>
              <div className='product-image-grid'>
                <div className='upload-box main'>
                  <img src={PreviewImage1} alt='Product 1' />
                  <input type='file' accept='image/*' onChange={handleImageChange1} />
                  {!imageFile1 && productmode === 'add' && (
                    <div className='upload-placeholder'>
                      <PlusOutlined />
                      <span>รูปหลัก</span>
                    </div>
                  )}
                </div>
                <div className='upload-box'>
                  <img src={PreviewImage2} alt='Product 2' />
                  <input type='file' accept='image/*' onChange={handleImageChange2} />
                  {!imageFile2 && productmode === 'add' && (
                    <div className='upload-placeholder'>
                      <PlusOutlined />
                      <span>รูป 2</span>
                    </div>
                  )}
                </div>
                <div className='upload-box'>
                  <img src={PreviewImage3} alt='Product 3' />
                  <input type='file' accept='image/*' onChange={handleImageChange3} />
                  {!imageFile3 && productmode === 'add' && (
                    <div className='upload-placeholder'>
                      <PlusOutlined />
                      <span>รูป 3</span>
                    </div>
                  )}
                </div>
              </div>
              <div className='upload-instructions'>
                <div className='instructions-title'>
                  <PlusOutlined style={{ color: '#fa8c16' }} />
                  <span>คำแนะนำในการอัปโหลดรูปภาพ</span>
                </div>
                <ul>
                  <li>รูปภาพแรก (รูปหลัก) จะถูกใช้เป็นหน้าปกหลักของสินค้า</li>
                  <li>ขนาดไฟล์ภาพแนะนำไม่เกิน 2MB ต่อรูปภาพ</li>
                  <li>สัดส่วนภาพที่แนะนำคือ 1:1 หรือ 4:3 เพื่อการแสดงผลที่สวยที่สุด</li>
                  <li>รองรับประเภทไฟล์รูปภาพ JPG, JPEG, PNG หรือ WebP</li>
                </ul>
              </div>
            </Col>

            <Col xs={24} md={14}>
              <Form.Item name='productitem_id' label='รหัสสินค้า'>
                <Input disabled />
              </Form.Item>
              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name='productcategory_id'
                    label='หมวดหมู่สินค้า'
                    rules={[{ required: true, message: 'กรุณาเลือกหมวดหมู่' }]}
                  >
                    <Select
                      options={productcategory_list.map((c) => ({
                        label: c.productcategory_name,
                        value: c.productcategory_id,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name='productitem_barcode'
                    label='บาร์โค้ด'
                    rules={[
                      { required: true, message: 'กรุณากรอก Barcode' },
                      { min: 5, message: 'Barcode ต้องมีอย่างน้อย 5 ตัวอักษร' },
                    ]}
                  >
                    <Input
                      suffix={
                        <Button
                          type='text'
                          size='small'
                          icon={<ScanOutlined style={{ color: '#fa8c16', fontSize: '16px' }} />}
                          onClick={() => setIsScannerOpen(true)}
                          title='สแกนบาร์โค้ด'
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: 'none',
                            padding: '4px',
                            height: 'auto',
                          }}
                        />
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                name='productitem_name'
                label='ชื่อสินค้า (ไทย)'
                rules={[
                  { required: true, message: 'กรุณากรอกชื่อสินค้า (ไทย)' },
                  { min: 5, message: 'ชื่อสินค้าต้องมีอย่างน้อย 5 ตัวอักษร' },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name='productitem_inter'
                label='ชื่อสินค้า (อังกฤษ)'
                rules={[
                  { required: true, message: 'กรุณากรอกชื่อสินค้า (อังกฤษ)' },
                  { min: 5, message: 'ชื่อสินค้าต้องมีอย่างน้อย 5 ตัวอักษร' },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name='productitem_desc'
                label='รายละเอียดสินค้า'
                rules={[
                  { required: true, message: 'กรุณากรอกรายละเอียดสินค้า' },
                  { min: 5, message: 'รายละเอียดสินค้าต้องมีอย่างน้อย 5 ตัวอักษร' },
                ]}
              >
                <Input.TextArea rows={4} />
              </Form.Item>

              <Text strong>ขนาดสินค้า</Text>
              <Row gutter={[8, 8]} style={{ marginTop: '8px' }}>
                <Col xs={12} sm={6}>
                  <Form.Item
                    name='productitem_width'
                    label='ความกว้าง (cm)'
                    rules={[{ required: true, message: 'กรุณากรอกความกว้าง' }]}
                  >
                    <InputNumber min={0.01} step={0.01} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Item
                    name='productitem_height'
                    label='ความยาว (cm)'
                    rules={[{ required: true, message: 'กรุณากรอกความยาว' }]}
                  >
                    <InputNumber min={0.01} step={0.01} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Item
                    name='productitem_deep'
                    label='ความสูง (cm)'
                    rules={[{ required: true, message: 'กรุณากรอกความสูง' }]}
                  >
                    <InputNumber min={0.01} step={0.01} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Item
                    name='productitem_weight'
                    label='น้ำหนัก (g)'
                    rules={[{ required: true, message: 'กรุณากรอกน้ำหนัก' }]}
                  >
                    <InputNumber min={0.01} step={0.01} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
              </Row>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '8px',
                  marginTop: '24px',
                }}
              >
                <Button
                  onClick={() => {
                    setProductItem_Selected({});
                    setIsModalOpen(false);
                  }}
                >
                  ยกเลิก
                </Button>
                <Button type='primary' htmlType='submit' loading={modalLoading}>
                  บันทึก
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>

      {isScannerOpen && (
        <BarcodeScanner
          onScanSuccess={(code) => {
            setIsScannerOpen(false);
            form.setFieldsValue({ productitem_barcode: code.trim() });
            message.success(`สแกนบาร์โค้ดสำเร็จ: ${code}`);
          }}
          onClose={() => setIsScannerOpen(false)}
        />
      )}

      {isSearchScannerOpen && (
        <BarcodeScanner
          onScanSuccess={(code) => {
            setIsSearchScannerOpen(false);
            setFiltertext(code.trim());
            message.success(`สแกนเพื่อค้นหาสำเร็จ: ${code}`);
          }}
          onClose={() => setIsSearchScannerOpen(false)}
        />
      )}
    </div>
  );
}

export default ProductItemPreview;
